var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Selecteer een tijd")]),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          options: _vm.options,
          value: _vm.value,
          placeholder: "Selecteer een tijd",
        },
        on: { input: _vm.updateValue },
      }),
      _vm._v(" "),
      _vm.value &&
      _vm.value.value &&
      _vm.value.value.spots &&
      _vm.value.value.max &&
      (_vm.value.value.spots / _vm.value.value.max) * 100 > 74
        ? _c("div", [
            _c("hr"),
            _vm._v(
              "\n    Er zijn nog " +
                _vm._s(_vm.value.value.spots) +
                " plekken beschikbaar!\n  "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Boek/Time.vue